import AppRouter from './router/routes';
import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/base.css';
import './assets/css/hover-effects.css';
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    // Prevent double scrollbar on page load
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    
    document.title = process.env.REACT_APP_NAME || 'React App';
     // Update existing meta tags
     const metaDescription = document.querySelector('meta[name="description"]');
     if (metaDescription) {
         metaDescription.content = process.env.REACT_APP_META_DESCRIPTION || 'React App Description';
     }

     const metaKeywords = document.querySelector('meta[name="keywords"]');
     if (metaKeywords) {
        metaKeywords.content = process.env.REACT_APP_META_KEYWORDS || 'React App keywords';
     }

     AOS.init({ 
       duration: 800,
       easing: 'ease-in-out',
       once: true,
       offset: 100,
       delay: 0,
       mirror: false,
       disable: false
     });
     
     // Refresh AOS after initialization to prevent layout shifts
     setTimeout(() => {
       AOS.refresh();
       // Ensure no double scrollbar after AOS refresh
       document.body.style.overflowX = 'hidden';
       document.documentElement.style.overflowX = 'hidden';
     }, 100);

}, []);



  return (
    <div>
      <ToastContainer />
      <AppRouter />
    </div>
  );
}

export default App;
